module.exports = __webpack_public_path__ + "static/media/candy.565edbe0.png";